import * as React from 'react'

import HoneygainCleanFooter from 'app/components/HoneygainCleanFooter'
import TopMenu from 'app/components/TopMenu'
import { useGlobalState } from 'app/store'

interface Props {
  children: React.ReactNode
}

const HoneyGainReferralMeLayout: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  const [menuItems] = useGlobalState('honeygainReferralMeMenu')

  return (
    <div>
      <TopMenu logoUrl="https://www.honeygain.com/" menuItems={menuItems || []} />
      {children}
      <HoneygainCleanFooter />
    </div>
  )
}

export default HoneyGainReferralMeLayout
